import { storeToRefs } from 'pinia';
import { Ref, computed, ref } from 'vue';

import { useRolesStore, useTeamStore } from '@/stores';
import { Invite, TeamAuthorization } from '@/types/team';

export type AuthOrInvite = (Invite | TeamAuthorization) & {
  user?: TeamAuthorization['user'];
};

export default function useAuthorizationsWithRoles(
  passedSelectedUserIds?: Ref<Set<number>>,
) {
  const teamStore = useTeamStore();
  const rolesStore = useRolesStore();
  const {
    authorizations,
    redeemableInvites,
    ready: teamReady,
  } = storeToRefs(teamStore);
  const { rolesById, ready: rolesReady } = storeToRefs(rolesStore);

  const selectedUserIds = passedSelectedUserIds ?? ref<Set<number>>(new Set());

  function attachRole(authOrInvite: AuthOrInvite) {
    return {
      ...authOrInvite,
      roleName: rolesById.value[authOrInvite?.role_id || '']?.name,
    };
  }

  const authsWithRoles = computed(() => authorizations.value.map(attachRole));
  const invitesWithRoles = computed(() =>
    redeemableInvites.value.map(attachRole),
  );

  return {
    authsWithRoles,
    invitesWithRoles,
    teamReady,
    rolesReady,
    selectedUserIds,
  };
}
